import type { FunctionComponent } from "react";

import CardValue from "~/components/Card/components/CardValue.tsx";
import Headline from "~/components/Headline/Headline";
import type { EInvoiceDocument } from "~/modules/billing/api/eInvoice/eInvoiceTypes.ts";

import { formatEInvoiceDate } from "../eInvoiceFormat.ts";

type Props = { document: EInvoiceDocument };

const EInvoiceDocumentSection: FunctionComponent<Props> = ({ document }) => (
	<div className="flex flex-col gap-3">
		<Headline type="h5">Allgemein</Headline>
		<CardValue label="Rechnungsnummer">{document.invoiceNumber}</CardValue>
		<CardValue label="Typ">{document.typeName} ({document.typeCode})</CardValue>
		<CardValue label="Rechnungsdatum">{formatEInvoiceDate(document.issueDate)}</CardValue>
		<CardValue label="Währung">{document.currencyCode}</CardValue>
		<CardValue label="Käuferreferenz">{document.buyerReference}</CardValue>
	</div>
);

export default EInvoiceDocumentSection;
